import { Box, Button, Grid2, Typography } from "@mui/material";
import React from "react";

const styles = (theme) => ({
  "& .actionBox": {
    marginTop: "15px",
    background: theme.palette.error.light,
    borderLeft: `2px solid ${theme.palette.error.main}`,
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    maxWidth: "300px",
    "& button": {
      marginTop: "10px",
      width: "fit-content",
    },
  },
});

const PendingActions = () => {
  return (
    <Grid2 sx={styles}>
      <Typography fontWeight={500} variant="title">
        Actions Pending on you
      </Typography>
      <Box className="actionBox">
        <Typography fontWeight={500}>
          Get part of your course fee back!
        </Typography>
        <Typography>
          With our new referral program, you can earn Rs 12,000 per referral and
          your friend gets Rs 10,000 discount.
        </Typography>
        <Button color="secondary" variant="outlined">
          Request Call Back
        </Button>
      </Box>
    </Grid2>
  );
};

export default PendingActions;
